import React, { useState } from 'react';
import { 
  Card, Table, Form, Input, Select, Button, Space, 
  Tag, Typography, message, Drawer, Descriptions, 
  Divider, Image, Modal, Badge, Radio, Tooltip, Tabs,
  Row, Col, Popconfirm
} from 'antd';
import { 
  SearchOutlined, 
  ReloadOutlined, 
  CheckCircleOutlined, 
  EyeOutlined,
  AlipayCircleOutlined,
  WechatOutlined,
  FileSearchOutlined,
  InfoCircleOutlined,
  BankOutlined,
  EditOutlined,
  PlusOutlined,
  DeleteOutlined
} from '@ant-design/icons';

const { Text, Title } = Typography;
const { Option } = Select;

const RechargeAudit = () => {
  const [activeTab, setActiveTab] = useState('audit');
  const [form] = Form.useForm();
  const [auditForm] = Form.useForm();
  const [accountForm] = Form.useForm();
  const [onlineAccountForm] = Form.useForm();
  const loading = false;
  const [auditVisible, setAuditVisible] = useState(false);
  const [accountModalVisible, setAccountModalVisible] = useState(false);
  const [onlineAccountModalVisible, setOnlineAccountModalVisible] = useState(false);
  const [detailModalVisible, setDetailModalVisible] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null);
  const [editingAccount, setEditingAccount] = useState(null);
  const [detailAccount, setDetailAccount] = useState(null);

  // 模拟对公账户数据
  const [bankAccountInfo, setBankAccountInfo] = useState({
    name: '南京鹤梦信息技术有限公司',
    bank: '南京建设银行南京江宁经济开发区支行',
    bankCode: '105301001049',
    accountNo: '3205 0159 6059 0000 0471'
  });

  // 模拟在线收款账户数据
  const [onlineAccounts, setOnlineAccounts] = useState([
    {
      id: 1,
      name: '鹤梦云支付宝账户',
      channel: 'alipay',
      appId: '2021002134567890',
      publicKey: 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA7...',
      privateKey: 'MIIEvAIBADANBgkqhkiG9w0BAQEFAASCBKYwggSiAgEAAo...',
      updateTime: '2026-03-20 10:00:00',
      operator: 'admin',
      isDefault: true
    },
    {
      id: 2,
      name: '鹤梦云微信账户',
      channel: 'wechat',
      mchId: '1567890123',
      appId: 'wx8888888888888888',
      apiKey: 'h7d8s9a0f6g5h4j3k2l1p9o8i7u6y5t4',
      updateTime: '2026-03-21 09:30:00',
      operator: 'admin',
      isDefault: false
    }
  ]);

  const handleSetDefault = (id) => {
    setOnlineAccounts(onlineAccounts.map(item => ({
      ...item,
      isDefault: item.id === id
    })));
    message.success('已设为默认账户');
  };

  // 模拟记录数据
  const mockRecords = [
    { id: 'REC20260317001', enterprise: '南京鹤梦信息技术有限公司', enterpriseId: 'HM-8827-X', amount: 1000.00, time: '2026-03-17 10:00:00', method: 'online', platform: '支付宝', callback: '支付成功', status: 'pending', voucher: '' },
    { id: 'REC20260316002', enterprise: '东莞康林物联网有限公司', enterpriseId: 'JGSf0Nd7', amount: 5000.00, time: '2026-03-16 14:30:00', method: 'offline', status: 'pending', voucher: 'https://via.placeholder.com/400x600?text=Remittance+Voucher' },
    { id: 'REC20260315003', enterprise: '捷顺科技股份有限公司', enterpriseId: 'A619355x', amount: 200.50, time: '2026-03-15 09:12:45', method: 'offline', status: 'pass', voucher: 'https://via.placeholder.com/400x600?text=Passed+Voucher', auditTime: '2026-03-15 11:00:00', auditor: 'admin' },
    { id: 'REC20260314004', enterprise: '南京鹤梦信息技术有限公司', enterpriseId: 'HM-8827-X', amount: 300.00, time: '2026-03-14 16:20:00', method: 'online', platform: '支付宝', callback: '支付失败', status: 'reject', rejectReason: '支付记录验证不通过，请核对交易号', auditTime: '2026-03-14 16:45:00', auditor: 'system' },
  ];

  const columns = [
    { title: '充值流水号', dataIndex: 'id', key: 'id', width: 160 },
    { title: '企业信息', key: 'enterprise', render: (_, record) => (<div><div style={{ fontWeight: 500 }}>{record.enterprise}</div><Text type="secondary" style={{ fontSize: 12 }}>ID: {record.enterpriseId}</Text></div>) },
    { title: '充值金额', dataIndex: 'amount', key: 'amount', align: 'right', render: (val) => <Text strong>¥ {val.toFixed(2)}</Text> },
    { 
      title: '充值方式', 
      key: 'method',
      render: (_, record) => (
        <div>
          <Space>
            {record.method === 'online' ? (
              <><AlipayCircleOutlined style={{ color: '#1677ff' }} /> 在线充值</>
            ) : (
              <><FileSearchOutlined style={{ color: '#fa8c16' }} /> 线下汇款</>
            )}
          </Space>
          <div style={{ fontSize: 12, color: '#8c8c8c', marginTop: 4 }}>
            {record.method === 'online' ? (
              <Space size={4}>
                <span>{record.platform || '支付宝'} |</span>
                <Badge status={record.callback === '支付成功' ? 'success' : 'error'} text={record.callback || '支付成功'} />
              </Space>
            ) : (
              record.voucher && (
                <Button type="link" size="small" style={{ padding: 0, fontSize: 12 }} icon={<EyeOutlined />} onClick={() => Modal.info({ title: '汇款凭证', width: 600, content: <div style={{ textAlign: 'center' }}><Image src={record.voucher} width="100%" /></div>, okText: '关闭' })}>查看凭证</Button>
              )
            )}
          </div>
        </div>
      )
    },
    { 
      title: '状态', 
      dataIndex: 'status', 
      key: 'status',
      sorter: (a, b) => a.status.localeCompare(b.status),
      render: (s, record) => {
        const config = { pending: { color: 'processing', text: '待审核' }, pass: { color: 'success', text: '已通过' }, reject: { color: 'error', text: '已驳回' } };
        const statusEl = <Badge status={config[s].color} text={config[s].text} />;
        if (s === 'reject' && record.rejectReason) {
          return (<Space>{statusEl}<Tooltip title={record.rejectReason}><InfoCircleOutlined style={{ color: '#ff4d4f', cursor: 'help' }} /></Tooltip></Space>);
        }
        return statusEl;
      }
    },
    { title: '提交时间', dataIndex: 'time', key: 'time', width: 170 },
    { title: '操作', key: 'action', width: 100, align: 'center', render: (_, record) => (<Button type="link" disabled={record.status !== 'pending'} onClick={() => { setCurrentRecord(record); setAuditVisible(true); }}>审核</Button>) },
  ];

  const onlineAccountColumns = [
    { title: '序号', dataIndex: 'id', key: 'id', width: 70 },
    { 
      title: '账户名', 
      dataIndex: 'name', 
      key: 'name',
      render: (text, record) => (
        <Space>
          {record.isDefault && <Tag style={{ backgroundColor: '#ff9d00', color: '#fff', border: 'none' }}>默认</Tag>}
          {text}
        </Space>
      )
    },
    { 
      title: '收款渠道', 
      dataIndex: 'channel', 
      key: 'channel',
      render: (channel) => (
        <Space>
          {channel === 'alipay' ? (
            <Tag color="blue" icon={<AlipayCircleOutlined />}>支付宝</Tag>
          ) : (
            <Tag color="success" icon={<WechatOutlined />}>微信</Tag>
          )}
        </Space>
      )
    },
    { 
      title: '账户详情', 
      key: 'details',
      render: (_, record) => (
        <Button type="link" size="small" icon={<EyeOutlined />} onClick={() => { setDetailAccount(record); setDetailModalVisible(true); }}>查看</Button>
      )
    },
    { title: '更新时间', dataIndex: 'updateTime', key: 'updateTime' },
    { title: '操作人', dataIndex: 'operator', key: 'operator' },
    { 
      title: '操作', 
      key: 'action',
      width: 200,
      render: (_, record) => (
        <Space split={<Divider type="vertical" />}>
          <Button 
            type="link" 
            size="small" 
            disabled={record.isDefault}
            onClick={() => handleSetDefault(record.id)}
          >
            设为默认
          </Button>
          <Button type="link" size="small" icon={<EditOutlined />} onClick={() => handleEditOnlineAccount(record)}>编辑</Button>
          <Popconfirm title="确定删除该收款账户吗？" onConfirm={() => handleDeleteOnlineAccount(record.id)} okText="确定" cancelText="取消">
            <Button type="link" size="small" danger icon={<DeleteOutlined />}>删除</Button>
          </Popconfirm>
        </Space>
      )
    }
  ];

  const handleAuditSubmit = async () => {
    try {
      const values = await auditForm.validateFields();
      message.success(`充值单 ${currentRecord.id} 审核${values.result === 'pass' ? '通过' : '驳回'}`);
      setAuditVisible(false);
      auditForm.resetFields();
    } catch (error) { console.log(error); }
  };

  const handleAccountSave = async () => {
    try {
      const values = await accountForm.validateFields();
      setBankAccountInfo({
        name: values.name,
        bank: values.bank,
        bankCode: values.bankCode,
        accountNo: values.accountNo
      });
      message.success('收款账户配置已更新');
      setAccountModalVisible(false);
    } catch (error) { console.log(error); }
  };

  const handleAddOnlineAccount = () => {
    setEditingAccount(null);
    onlineAccountForm.resetFields();
    setOnlineAccountModalVisible(true);
  };

  const handleEditOnlineAccount = (record) => {
    setEditingAccount(record);
    onlineAccountForm.setFieldsValue(record);
    setOnlineAccountModalVisible(true);
  };

  const handleDeleteOnlineAccount = (id) => {
    setOnlineAccounts(onlineAccounts.filter(item => item.id !== id));
    message.success('收款账户已删除');
  };

  const handleOnlineAccountSave = async () => {
    try {
      const values = await onlineAccountForm.validateFields();
      const now = new Date().toLocaleString();
      
      if (editingAccount) {
        setOnlineAccounts(onlineAccounts.map(item => 
          item.id === editingAccount.id ? { ...item, ...values, updateTime: now, operator: 'admin' } : item
        ));
        message.success('收款账户已更新');
      } else {
        const newAccount = {
          id: onlineAccounts.length > 0 ? Math.max(...onlineAccounts.map(a => a.id)) + 1 : 1,
          ...values,
          updateTime: now,
          operator: 'admin'
        };
        setOnlineAccounts([...onlineAccounts, newAccount]);
        message.success('收款账户已新增');
      }
      setOnlineAccountModalVisible(false);
    } catch (error) { console.log(error); }
  };

  return (
    <div style={{ padding: '24px' }}>
      <div style={{ marginBottom: 16 }}>
        <Title level={4}>充值审核</Title>
      </div>
      <Tabs 
        activeKey={activeTab} 
        onChange={setActiveTab}
        items={[
          {
            key: 'audit',
            label: '充值审核',
            children: (
              <>
                <Card bordered={false} style={{ marginBottom: 16 }}>
                  <Form form={form} layout="inline">
                    <Form.Item name="id"><Input placeholder="流水号" allowClear style={{ width: 180 }} /></Form.Item>
                    <Form.Item>
                      <Form.Item shouldUpdate={(p, c) => p.entSearchType !== c.entSearchType} noStyle>
                        {({ getFieldValue }) => {
                          const type = getFieldValue('entSearchType') || 'name';
                          return (
                            <Space.Compact style={{ width: '100%' }}>
                              <Form.Item name="entSearchType" initialValue="name" noStyle><Select style={{ width: 100 }}><Option value="name">企业名称</Option><Option value="id">企业ID</Option></Select></Form.Item>
                              <Form.Item name="enterprise" noStyle><Input placeholder={type === 'name' ? "输入企业名称" : "请输入企业ID"} allowClear style={{ width: 180 }} /></Form.Item>
                            </Space.Compact>
                          );
                        }}
                      </Form.Item>
                    </Form.Item>
                    <Form.Item name="status"><Select placeholder="审核状态" style={{ width: 150 }} allowClear><Option value="pending">待审核</Option><Option value="pass">已通过</Option><Option value="reject">已驳回</Option></Select></Form.Item>
                    <Form.Item><Space><Button type="primary" icon={<SearchOutlined />}>查询</Button><Button icon={<ReloadOutlined />} onClick={() => form.resetFields()}>重置</Button></Space></Form.Item>
                  </Form>
                </Card>
                <Card bordered={false} title={<Space><CheckCircleOutlined /><span>充值审核列表</span></Space>}><Table columns={columns} dataSource={mockRecords} rowKey="id" loading={loading} pagination={{ showTotal: (total) => `共 ${total} 条记录` }} /></Card>
              </>
            )
          },
          {
            key: 'account',
            label: '充值账户',
            children: (
              <Space direction="vertical" style={{ width: '100%' }} size={16}>
                <Card 
                  title={<Space><BankOutlined /><span>平台对公收款账户</span></Space>}
                  bordered={false}
                  extra={<Button type="link" icon={<EditOutlined />} onClick={() => { accountForm.setFieldsValue(bankAccountInfo); setAccountModalVisible(true); }}>配置</Button>}
                >
                  <div style={{ padding: '8px 0' }}>
                    <Row gutter={[48, 24]}>
                      <Col span={12}><Space size={12}><Text type="secondary">收款户名:</Text><Text strong style={{ fontSize: 15 }}>{bankAccountInfo.name}</Text></Space></Col>
                      <Col span={12}><Space size={12}><Text type="secondary">收款银行:</Text><Text strong style={{ fontSize: 15 }}>{bankAccountInfo.bank}</Text></Space></Col>
                      <Col span={12}><Space size={12}><Text type="secondary">开户行号:</Text><Text strong style={{ fontSize: 15 }}>{bankAccountInfo.bankCode}</Text></Space></Col>
                      <Col span={12}><Space size={12}><Text type="secondary">银行账号:</Text><Text strong style={{ fontSize: 15 }}>{bankAccountInfo.accountNo}</Text></Space></Col>
                    </Row>
                  </div>
                </Card>

                <Card 
                  title={<Space><AlipayCircleOutlined /><span>在线收款账户列表</span></Space>}
                  bordered={false}
                  extra={<Button type="primary" icon={<PlusOutlined />} onClick={handleAddOnlineAccount}>新增收款账户</Button>}
                >
                  <Table 
                    columns={onlineAccountColumns} 
                    dataSource={onlineAccounts} 
                    rowKey="id" 
                    pagination={false} 
                  />
                </Card>
              </Space>
            )
          }
        ]}
      />

      {/* 充值审核抽屉 */}
      <Drawer
        title="充值申请审核"
        width={600}
        onClose={() => setAuditVisible(false)}
        open={auditVisible}
        destroyOnClose
        footer={
          <div style={{ textAlign: 'right', padding: '10px 16px', background: '#fff', borderTop: '1px solid #f0f0f0' }}>
            <Button onClick={() => setAuditVisible(false)} style={{ marginRight: 8 }}>取消</Button>
            <Button type="primary" onClick={handleAuditSubmit}>确认审核</Button>
          </div>
        }
      >
        {currentRecord && (
          <div style={{ padding: '0 8px' }}>
            <Descriptions title="基本信息" bordered column={1} size="small" style={{ marginBottom: 24 }}><Descriptions.Item label="申请企业">{currentRecord.enterprise}</Descriptions.Item><Descriptions.Item label="企业ID">{currentRecord.enterpriseId}</Descriptions.Item><Descriptions.Item label="流水号">{currentRecord.id}</Descriptions.Item><Descriptions.Item label="充值金额"><Text strong style={{ color: '#f50', fontSize: 16 }}>¥ {currentRecord.amount.toFixed(2)}</Text></Descriptions.Item><Descriptions.Item label="申请时间">{currentRecord.time}</Descriptions.Item><Descriptions.Item label="充值方式">{currentRecord.method === 'online' ? (<Space><span>在线充值 ({currentRecord.platform})</span><Badge status={currentRecord.callback === '支付成功' ? 'success' : 'error'} text={currentRecord.callback} /></Space>) : '线下汇款'}</Descriptions.Item></Descriptions>
            {currentRecord.method === 'offline' && (<div style={{ marginBottom: 24 }}><Title level={4}>汇款凭证</Title><div style={{ padding: '16px', background: '#f5f5f5', borderRadius: 8, textAlign: 'center' }}><Image src={currentRecord.voucher} width="100%" style={{ borderRadius: 4 }} /></div></div>)}
            <Divider /><Title level={4} style={{ marginBottom: 16 }}>审核操作</Title>
            <Form form={auditForm} layout="vertical" initialValues={{ result: 'pass' }}>
              <Form.Item name="result" label="审核结果" required><Radio.Group><Radio value="pass">审核通过</Radio><Radio value="reject">审核驳回</Radio></Radio.Group></Form.Item>
              <Form.Item noStyle shouldUpdate={(p, c) => p.result !== c.result}>{({ getFieldValue }) => getFieldValue('result') === 'reject' ? (<Form.Item name="reason" label="驳回原因" rules={[{ required: true, message: '请输入驳回原因' }]}><Input.TextArea placeholder="请输入驳回原因" rows={4} maxLength={200} showCount /></Form.Item>) : null}</Form.Item>
            </Form>
          </div>
        )}
      </Drawer>

      {/* 对公账户配置弹窗 */}
      <Modal
        title="配置对公收款账户"
        open={accountModalVisible}
        onOk={handleAccountSave}
        onCancel={() => setAccountModalVisible(false)}
        okText="保存"
        cancelText="取消"
        destroyOnClose
      >
        <Form form={accountForm} layout="vertical" style={{ marginTop: 16 }}>
          <Form.Item name="name" label="收款户名" rules={[{ required: true, message: '请输入收款户名' }]}><Input placeholder="请输入收款户名" /></Form.Item>
          <Form.Item name="bank" label="收款银行" rules={[{ required: true, message: '请输入收款银行' }]}><Input placeholder="请输入收款银行" /></Form.Item>
          <Form.Item name="bankCode" label="开户行号" rules={[{ required: true, message: '请输入开户行号' }]}><Input placeholder="请输入开户行号" /></Form.Item>
          <Form.Item name="accountNo" label="银行账号" rules={[{ required: true, message: '请输入银行账号' }]}><Input placeholder="请输入银行账号" /></Form.Item>
        </Form>
      </Modal>

      {/* 在线收款账户新增/编辑弹窗 */}
      <Modal
        title={editingAccount ? "编辑收款账户" : "新增收款账户"}
        open={onlineAccountModalVisible}
        onOk={handleOnlineAccountSave}
        onCancel={() => setOnlineAccountModalVisible(false)}
        okText="保存账户"
        cancelText="取消"
        width={600}
        destroyOnClose
      >
        <Form form={onlineAccountForm} layout="vertical" style={{ marginTop: 16 }} initialValues={{ channel: 'alipay' }}>
          <Form.Item name="channel" label="支付渠道" rules={[{ required: true, message: '请选择支付渠道' }]}>
            <Select placeholder="请选择支付渠道">
              <Option value="alipay">支付宝</Option>
              <Option value="wechat">微信</Option>
            </Select>
          </Form.Item>
          <Form.Item name="name" label="账户名" rules={[{ required: true, message: '请输入账户名' }]}>
            <Input placeholder="请输入账户名" />
          </Form.Item>
          
          <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.channel !== currentValues.channel}>
            {({ getFieldValue }) => {
              const channel = getFieldValue('channel');
              if (channel === 'alipay') {
                return (
                  <>
                    <Form.Item name="appId" label="AppID" rules={[{ required: true, message: '请输入AppID' }]}><Input placeholder="请输入支付宝 AppID" /></Form.Item>
                    <Form.Item name="publicKey" label="公钥" rules={[{ required: true, message: '请输入公钥' }]}><Input.TextArea placeholder="请输入支付宝公钥" rows={3} /></Form.Item>
                    <Form.Item name="privateKey" label="密钥" rules={[{ required: true, message: '请输入密钥' }]}><Input.TextArea placeholder="请输入支付宝私钥" rows={3} /></Form.Item>
                  </>
                );
              } else if (channel === 'wechat') {
                return (
                  <>
                    <Form.Item name="mchId" label="商户ID" rules={[{ required: true, message: '请输入商户ID' }]}><Input placeholder="请输入微信支付商户ID" /></Form.Item>
                    <Form.Item name="appId" label="AppID" rules={[{ required: true, message: '请输入AppID' }]}><Input placeholder="请输入微信支付 AppID" /></Form.Item>
                    <Form.Item name="apiKey" label="密钥" rules={[{ required: true, message: '请输入密钥' }]}><Input.TextArea placeholder="请输入微信支付 API 密钥" rows={3} /></Form.Item>
                  </>
                );
              }
              return null;
            }}
          </Form.Item>
        </Form>
      </Modal>

      {/* 账户详情查看弹窗 */}
      <Modal
        title="收款账户详情"
        open={detailModalVisible}
        onCancel={() => setDetailModalVisible(false)}
        footer={[<Button key="close" onClick={() => setDetailModalVisible(false)}>关闭</Button>]}
        width={600}
      >
        {detailAccount && (
          <Descriptions bordered column={1} size="small" style={{ marginTop: 16 }}>
            <Descriptions.Item label="账户名称">{detailAccount.name}</Descriptions.Item>
            <Descriptions.Item label="收款渠道">
              {detailAccount.channel === 'alipay' ? <Tag color="blue">支付宝</Tag> : <Tag color="success">微信</Tag>}
            </Descriptions.Item>
            {detailAccount.channel === 'alipay' ? (
              <>
                <Descriptions.Item label="AppID">{detailAccount.appId}</Descriptions.Item>
                <Descriptions.Item label="公钥"><div style={{ wordBreak: 'break-all', maxHeight: 100, overflowY: 'auto' }}>{detailAccount.publicKey}</div></Descriptions.Item>
                <Descriptions.Item label="密钥"><div style={{ wordBreak: 'break-all', maxHeight: 100, overflowY: 'auto' }}>{detailAccount.privateKey}</div></Descriptions.Item>
              </>
            ) : (
              <>
                <Descriptions.Item label="商户ID">{detailAccount.mchId}</Descriptions.Item>
                <Descriptions.Item label="AppID">{detailAccount.appId}</Descriptions.Item>
                <Descriptions.Item label="密钥"><div style={{ wordBreak: 'break-all', maxHeight: 100, overflowY: 'auto' }}>{detailAccount.apiKey}</div></Descriptions.Item>
              </>
            )}
            <Descriptions.Item label="最后更新">{detailAccount.updateTime}</Descriptions.Item>
            <Descriptions.Item label="操作人">{detailAccount.operator}</Descriptions.Item>
          </Descriptions>
        )}
      </Modal>
    </div>
  );
};

export default RechargeAudit;
